import TableWidget from '../table-builder/table-widget'
import { ComponentPreviewProps } from './types'

const Table = (props: ComponentPreviewProps) => {
  return <TableWidget {...props} />
}

export default Table
